import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { galleryWork, galleryRenders, galleryPhotos } from "../data/portfolio";

export default function Gallery() {
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % galleryPhotos.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="gallery" className="section">
      <div className="section-header">
        <span className="section-label">Visual</span>
        <h2>Gallery</h2>
        <p className="section-desc">
          Lab work, cleanroom fabrication, and 3D renders from research projects.
        </p>
      </div>

      <div className="gallery-grid">
        {galleryWork.map((item, i) => (
          <motion.div
            key={item.src + i}
            className="gallery-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.4 }}
          >
            <img src={item.src} alt={item.title} loading="lazy" />
            <div className="gallery-caption">{item.title}</div>
          </motion.div>
        ))}
      </div>

      <div className="gallery-divider">
        <span className="divider-line" />
        <span className="divider-text">3D Renders · Blender</span>
        <span className="divider-line" />
      </div>

      <div className="gallery-grid renders-grid">
        {galleryRenders.map((item, i) => (
          <motion.div
            key={item.title}
            className="gallery-card render-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06, duration: 0.4 }}
          >
            <img src={item.src} alt={item.title} loading="lazy" />
            <div className="gallery-caption">{item.title}</div>
          </motion.div>
        ))}
      </div>

      <div className="photo-carousel">
        <img
          src={galleryPhotos[slideIndex]}
          alt={`Research photography ${slideIndex + 1}`}
          className="carousel-image"
        />
        <div className="carousel-dots">
          {galleryPhotos.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`carousel-dot ${i === slideIndex ? "active" : ""}`}
              onClick={() => setSlideIndex(i)}
              aria-label={`Show photo ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
